import { __rest } from 'tslib';
import React from 'react';
import { StyledTextLink } from './TextLink.styles.mjs';

const TextLink = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(StyledTextLink, Object.assign({}, props), children);
};

export { TextLink as default };
//# sourceMappingURL=TextLink.mjs.map
